import React from 'react';
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'

import Home from '../../../assets/home.svg';

import './index.scss';

export default () => <Link to={`/`} className="link">
  <Home className="home" />
</Link>
